import { ViewPath } from 'src/utils';

/**
 * 检测当前页面的 url 是否有效
 */
export const checkUrl = (pageId: string | undefined, domain?: string) => {
  if (!pageId && !domain) return false;
  const isSubscribeUrl = location.pathname.includes(ViewPath.subscribe);
  if (isSubscribeUrl) return false;
  const isChatUrl = location.pathname.includes(ViewPath.chat);
  if (isChatUrl) return false;
  return (
    !location.pathname.startsWith(`/${domain}`) && location.pathname !== ViewPath.main && !pageId
  );
};
